/* eslint-disable
 */
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import { Auth } from 'app/scripts/db/auth';

import { stopPropagationAndPreventDefault } from 'app/src/stopPropagationAndPreventDefault';
import { Analytics } from '@trello/atlassian-analytics';

const getFilteredActionsCount = function (model) {
  const showDetails = !Auth.isLoggedIn() || Auth.me().getShowDetails();
  const filteredActions = model.actionList.filter(function (action) {
    if (showDetails) {
      return true;
    } else {
      return action.isCommentLike();
    }
  });

  return filteredActions.length;
};

const showDetails = function (e) {
  stopPropagationAndPreventDefault(e);
  Analytics.sendClickedButtonEvent({
    buttonName: 'showDetailsButton',
    source: 'cardDetailScreen',
    containers: this.model.getAnalyticsContainers(),
  });
  Auth.me().setShowDetails(true);
  this.getData();
  return this.renderActionList();
};

const hideDetails = function (e) {
  stopPropagationAndPreventDefault(e);
  Analytics.sendClickedButtonEvent({
    buttonName: 'hideDetailsButton',
    source: 'cardDetailScreen',
    containers: this.model.getAnalyticsContainers(),
  });
  Auth.me().setShowDetails(false);
  this.getData();
  return this.renderActionList();
};

const showAllActions = function (e) {
  this.fShowAllActions = true;
  this.renderShowAllActionsButton();
  return this.getData();
};

const renderShowAllActionsButton = function () {
  const isMoreToShow =
    getFilteredActionsCount(this.model) >= this.defaultActionLimit;
  const hideButton = this.fShowAllActions || !isMoreToShow;
  this.$('.js-show-all-actions').toggleClass('hide', hideButton);

  return this;
};

const renderActionList = function () {
  const showDetails = !Auth.isLoggedIn() || Auth.me().getShowDetails();
  this.actionListView.setShowDetails(showDetails);
  this.waitForId(this.model, () => this.actionListView.render());
  this.$('.js-show-details').toggleClass('hide', showDetails);
  this.$('.js-hide-details').toggleClass('hide', !showDetails);
  return this;
};

const renderSuggestedActions = function () {
  const canJoin = this.model.isValidSuggestion({ type: 'join' });
  const isOnBoardTemplate = this.model.isOnBoardTemplate();
  this.$('.js-suggested-actions').toggleClass(
    'hide',
    !canJoin || isOnBoardTemplate,
  );
  if (canJoin) {
    Analytics.sendViewedComponentEvent({
      componentType: 'section',
      componentName: 'suggestedActionsSection',
      source: 'cardDetailScreen',
      containers: {
        card: { id: this.model.id },
        board: { id: this.model.get('idBoard') },
        list: { id: this.model.get('idList') },
        organization: { id: this.model.getBoard()?.get('idOrganization') },
      },
    });
  }
  return this;
};

export { getFilteredActionsCount };
export { showDetails };
export { hideDetails };
export { showAllActions };
export { renderShowAllActionsButton };
export { renderActionList };
export { renderSuggestedActions };
